import gql from "graphql-tag";

const createWorkShift = gql`
  mutation(
    $code: String!
    $title: String
    $dayInWeeks: String
    $startTime: DateTime
    $endTime: DateTime
    $startBreakTime: DateTime
    $endBreakTime: DateTime
    $duration: Float
    $coefficient: Float
    $isOvertime: Boolean
    $description: String
    $departmentIds: [ID!]
    $branchLocationId: ID
    $makePayrollDate: Int
    $workOvertimeRateId: ID
  ) {
    createWorkShift(
      data: {
        code: $code
        title: $title
        dayInWeeks: $dayInWeeks
        startTime: $startTime
        endTime: $endTime
        startBreakTime: $startBreakTime
        endBreakTime: $endBreakTime
        duration: $duration
        coefficient: $coefficient
        isOvertime: $isOvertime
        description: $description
        departmentIds: $departmentIds
        branchLocationId: $branchLocationId
        makePayrollDate: $makePayrollDate
        workOvertimeRateId: $workOvertimeRateId
      }
    ) {
      id
      title
      code
      description
      dayInWeeks
      startTime
      endTime
      startBreakTime
      endBreakTime
      duration
      coefficient
      isOvertime
      createdAt
      updatedAt
    }
  }
`;

const updateWorkShift = gql`
  mutation(
    $id: ID!
    $code: String
    $title: String
    $dayInWeeks: String
    $description: String
    $startTime: DateTime
    $endTime: DateTime
    $startBreakTime: DateTime
    $endBreakTime: DateTime
    $duration: Float
    $coefficient: Float
    $isOvertime: Boolean
    $departmentIds: [ID!]
    $branchLocationId: ID
    $makePayrollDate: Int
    $workOvertimeRateId: ID
  ) {
    updateWorkShift(
      id: $id
      data: {
        code: $code
        title: $title
        dayInWeeks: $dayInWeeks
        startTime: $startTime
        endTime: $endTime
        startBreakTime: $startBreakTime
        endBreakTime: $endBreakTime
        duration: $duration
        coefficient: $coefficient
        isOvertime: $isOvertime
        description: $description
        departmentIds: $departmentIds
        branchLocationId: $branchLocationId
        makePayrollDate: $makePayrollDate
        workOvertimeRateId: $workOvertimeRateId
      }
    ) {
      id
      title
      code
      description
      dayInWeeks
      startTime
      endTime
      startBreakTime
      endBreakTime
      duration
      coefficient
      isOvertime
      createdAt
      updatedAt
    }
  }
`;

const deleteWorkShift = gql`
  mutation($id: ID!) {
    deleteWorkShift(id: $id) {
      id
    }
  }
`;

const getAllWorkShift = gql`
  query($limit: Int, $page: Int, $query: String) {
    getAllWorkShift(query: $query, paging: { limit: $limit, page: $page }) {
      id
      title
      code
      description
      dayInWeeks
      startTime
      endTime
      duration
      coefficient
      isOvertime
      createdAt
      updatedAt
      makePayrollDate
    }
  }
`;

const getWorkShift = gql`
  query($id: ID!) {
    getWorkShift(id: $id) {
      id
      title
      code
      description
      dayInWeeks
      startTime
      endTime
      startBreakTime
      endBreakTime
      duration
      coefficient
      isOvertime
      createdAt
      updatedAt
      branchLocationId
      makePayrollDate
      workOvertimeRateId
      workOvertimeRate {
        id
        name
      }
      branchLocation {
        id
        name
      }
      departments {
        id
        name
      }
      author {
        id
        username
        fullname
      }
    }
  }
`;

export default {
  createWorkShift,
  updateWorkShift,
  deleteWorkShift,
  getAllWorkShift,
  getWorkShift,
};
